'use client';

import { useState } from 'react';
import { CmsImage } from '@/components/CmsImage';
import { Modal } from '@/components/Modal';
import { VideoPlayer } from '@/components/VideoPlayer';
import { cmsSize } from '@/lib/cmsSize';
import { cn } from '@/lib/cn';
import type { CmsContainerHeight, CmsEmbedObject, CmsImageData, CmsSize } from '@/services/cms-sdk';
import type { CmsContainerWidth } from '@/services/cms-sdk/schemas/models/CmsContainerWidth';
import { cmsHeightToClassName } from '@/styles/global';
export type VideoModalProps = {
  background?: CmsImageData;
  video?: CmsEmbedObject;
  modalWidth?: CmsContainerWidth;
  className?: string;
  height?: CmsContainerHeight;
  borderRadius?: CmsSize;
};
export function VideoModal({
  video,
  modalWidth,
  background,
  className,
  height,
  borderRadius
}: VideoModalProps) {
  const [open, setOpen] = useState(false);
  if (!video?.sourceUrl) {
    return null;
  }
  const fluidHeight = !height || height === 'Fluid';
  return <>
            <div onClick={() => setOpen(true)} className={cn('relative cursor-pointer overflow-hidden text-center', cmsSize.asBorderRadius(borderRadius), {
      'mx-auto max-w-full': fluidHeight,
      [cmsHeightToClassName(height)]: !fluidHeight,
      'hover:[&_img]:brightness-110 hover:[&_img]:scale-105 ': true
    }, className)} style={{
      ...(fluidHeight && background?.width && background?.height ? {
        width: `${background.width}px`,
        aspectRatio: `${background.width} / ${background.height}`
      } : undefined)
    }}>
                {background ? <CmsImage {...background} className="transition-all transition-filter duration-300 ease-in-out rounded-[inherit] m-auto" enableFocusPoint={!fluidHeight} /> : null}
                <button className="btn text-primary lg:py-6 lg:px-8 abs-center">Watch</button>
            </div>
            <Modal className="[&_.modal-box]:p-0 overflow-hidden" width={modalWidth} open={open} onClose={() => setOpen(false)} showClose={true}>
                {open ? <VideoPlayer crossOrigin="anonymous" controls={false} className={cn('rounded-4xl bg-black overflow-hidden object-contain  max-h-[97vh] ', {
        'aspect-(--aspect)': video.width && video.height,
        'aspect-video': modalWidth ? !video.width || !video.height : true
      })} style={{
        ...(video.width && video.height ? {
          '--aspect': `${video.width} / ${video.height}`
        } : undefined)
      }} src={video?.sourceUrl} config={{
        youtube: {
          iv_load_policy: 3,
          fs: 1,
          color: 'white',
          rel: 0,
          referrerpolicy: 'strict-origin-when-cross-origin'
        }
      }} playing={open} width="100%" height="auto" /> : null}
            </Modal>
        </>;
}